import BaseAction from "./BaseAction";
import UnresolvedDisputeReducer from "../reducers/UnresolvedDisputeReducer";

class UnresolvedDisputeAction extends BaseAction {
  onClose = () => {};

  reset = () => {
    const { machines } = this.data();
    this.dispatch({ ...this.reducer.initialState, machines });
  };
}

const action = new UnresolvedDisputeAction(UnresolvedDisputeReducer);

export default action;
